import { useState } from 'react';
import { client } from '@/lib/api';

export function CarrierPanel({ orderNo }) {
  const [draft, setDraft] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  async function run(action) {
    setBusy(true); setError(''); setMessage('');
    try { await action(); }
    catch (e) { setError(e.response?.data?.detail || 'Kargo işlemi tamamlanamadı.'); }
    finally { setBusy(false); }
  }
  const prepare = () => run(async () => {
    const r = await client.get(`/admin/orders/${encodeURIComponent(orderNo)}/carrier/draft`);
    setDraft(r.data);
  });
  const check = () => run(async () => {
    const r = await client.post('/admin/carrier/check-connection');
    setMessage(`${r.data.message} (${r.data.environment === 'test' ? 'Test hesabı' : 'Canlı hesap'})`);
  });
  return <div data-testid="yurtici-panel" style={{ marginBottom: 18 }}>
    <div className="row-actions wrap">
      <button className="btn ghost" disabled={busy} onClick={prepare} data-testid="cargo-draft">Kargo taslağını hazırla</button>
      <button className="btn ghost" disabled={busy} onClick={check} data-testid="cargo-check">Yurtiçi bağlantısını kontrol et</button>
    </div>
    {busy && <p className="muted">Kontrol ediliyor…</p>}
    {message && <p className="ok" role="status">{message}</p>}
    {error && <p className="error" role="alert">{error}</p>}
    {draft && <div data-testid="cargo-draft-preview">
      <p className="muted">{draft.note}</p>
      <dl><dt>Alıcı</dt><dd>{draft.shipment.receiverCustName}</dd>
        <dt>Adres</dt><dd>{draft.shipment.receiverAddress} · {draft.shipment.townName} / {draft.shipment.cityName}</dd>
        <dt>Telefon</dt><dd>{draft.shipment.receiverPhone1}</dd>
        <dt>Kargo anahtarı</dt><dd>{draft.shipment.cargoKey}</dd>
        <dt>Ödeme</dt><dd>Gönderici ödemeli</dd></dl>
      {draft.warnings.map(w => <p className="error" key={w}>{w}</p>)}
    </div>}
  </div>;
}
